import { makeVar } from "@apollo/client";
import { getTestIdentity } from "@shared/utils.cookies";

import { getBpLdId } from "utils/getBpLdId";

export const testIdentity = makeVar<string>(getTestIdentity());
export const bpLdId = makeVar<string>(getBpLdId());
